<mat-toolbar class="main-toolbar">
  <mat-toolbar-row>
    <app-date-navigator
      (dateChange)="selectDate($event)"
      [selectedDate]="selectedDate"
    ></app-date-navigator>
    <span>
      {{
        selectedDate
          | amCalendar
            : {
                sameDay: "[Today]",
                nextDay: "[Tomorrow]",
                nextWeek: "dddd",
                lastDay: "[Yesterday]",
                lastWeek: "[Last] dddd",
                sameElse: "dddd"
              }
      }}
    </span>
    <span class="date-field-separator"></span>
    <input
      #timeFromText
      [value]="timeFromTextValue"
      hidden
      matInput
      placeholder="Start Time"
      readonly
      required
      type="text"
    />

    <mat-select
      #timeFromSelect
      (valueChange)="hourFromSelected(startHourField.value)"
      [formControl]="startHourField"
      class="time-selector"
    >
      @for (record of hourSelection; track record) {
        <mat-option [value]="record.val">{{ record.display }}</mat-option>
      }
    </mat-select>
    <span class="date-field-separator">to</span>

    <mat-select
      #timeToSelect
      (valueChange)="hourToSelected(endHourField.value)"
      [formControl]="endHourField"
      class="time-selector"
    >
      @for (record of hourSelection; track record) {
        <mat-option [value]="record.val">{{ record.display }}</mat-option>
      }
    </mat-select>
    <input
      #timeToText
      [value]="timeToTextValue"
      hidden
      matInput
      placeholder="End Time"
      readonly
      required
      type="text"
    />

    <mat-checkbox [formControl]="todayField">Today</mat-checkbox>
    <mat-checkbox [formControl]="mapField">Map</mat-checkbox>
    <mat-checkbox
      (change)="activeOnlyChanged($event.checked)"
      [checked]="scheduler.isActiveOnly()"
      matTooltip="Hide diaries with no positive shifts in the current view"
      >Active only</mat-checkbox
    >

    <span class="spacer"></span>

    <button
      (click)="openMeetingForm()"
      matTooltip="Schedule a New Meeting"
      mat-icon-button
    >
      <mat-icon>add</mat-icon>
    </button>
  </mat-toolbar-row>
</mat-toolbar>
<div [hidden]="!scheduler.error">
  <mat-card>
    Error Connecting to Server
    <button (click)="scheduler.performInit()" mat-raised-button>Retry</button>
  </mat-card>
</div>
<app-schedule-viewer
  #scheduler
  (layoutChange)="columnsChanged()"
  [hidden]="scheduler.error"
  [showMap]="mapField.value"
  class="sch-container"
></app-schedule-viewer>
